import type { ReactNode } from "react";
import PageLoader from "@/components/PageLoader";
import { useOwnerGuard } from "@/hooks/useOwnerGuard";

/**
 * Route-level session gate for `/owner/*`.
 *
 * Applied at the route rather than inside each page: the console is seven
 * routes today and the guard belongs to the surface, not to each screen. A page
 * added later is covered by the same boundary instead of having to remember it.
 *
 * While the session resolves — and while the redirect to /auth is in flight —
 * nothing of the page is rendered, so no page-level fetch can run and turn
 * "not signed in" into an empty result set.
 */
export const OwnerRoute = ({ children }: { children: ReactNode }) => {
  const { ready } = useOwnerGuard();
  if (!ready) return <PageLoader />;
  return <>{children}</>;
};

export default OwnerRoute;
